<template>
  <div id="dashboard-company">
    <section class="section is-paddingless">
      <search-for-candidates />
    </section>
  </div>
</template>

<script>
import SearchForCandidates from '@/components/SearchForCandidates/SearchForCandidates';

export default {
  name: 'DashboardCompany',
  components: {
    SearchForCandidates
  },
  data () {
    return {};
  }
};
</script>

<style scoped lang="scss">
</style>
